import apiClient from 'services/_infra/apiClient';

export async function createVoiceRoom(name, conversationId) {
  const response = await apiClient.post('/messaging/voice/rooms', { name, conversationId });
  return response.data;
}

export async function getVoiceRooms() {
  const response = await apiClient.get('/messaging/voice/rooms');
  return response.data;
}

export async function getVoiceRoom(roomId) {
  const response = await apiClient.get(`/messaging/voice/rooms/${roomId}`);
  return response.data;
}

export async function leaveVoiceRoom(roomId) {
  const response = await apiClient.post(`/messaging/voice/rooms/${roomId}/leave`);
  return response.data;
}

export async function endVoiceRoom(roomId) {
  const response = await apiClient.delete(`/messaging/voice/rooms/${roomId}`);
  return response.data;
}
